import { render, staticRenderFns } from "./PartnerPerformanceInfo.vue?vue&type=template&id=cd407558&scoped=true"
import script from "./PartnerPerformanceInfo.vue?vue&type=script&lang=js"
export * from "./PartnerPerformanceInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerPerformanceInfo.vue?vue&type=style&index=0&id=cd407558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd407558",
  null
  
)

export default component.exports